const selectors = {
    cartDrawer: 'cart-drawer',
    cartIconBubble: '#cart-icon-bubble',
    shopifySection: '.shopify-section',
    checkoutButton: '#CartDrawer-Checkout',
};
const events = ['frank-green:bundle-product-removed', 'frank-green:discount-applied', 'frank-green:gift-wrapping-update', 'frank-green:donation-update', 'frank-green:quick-add-update', 'frank-green:gift-card-added-to-cart'];
const updateCartDrawerElements = () => {
    const cartDrawer = document.querySelector(selectors.cartDrawer);
    events.forEach((event) => {
        window.addEventListener(event, () => {
            fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
                .then((response) => response.text())
                .then((text) => {
                const html = new DOMParser().parseFromString(text, 'text/html');
                const elements = ['.drawer__free-shipping-message', '.drawer__empty', '.drawer__items', '.drawer__gift-wrapping', '.drawer__donation', '.drawer__discount', '.drawer__recommendations .embla', '.drawer__footer'];
                for (const element of elements) {
                    const targetElement = cartDrawer.querySelector(element);
                    const sourceElement = html.querySelector(element);
                    if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                    }
                }
            })
                .then(() => {
                window.dispatchEvent(new CustomEvent('frank-green:cart-reloaded'));
            })
                .then(() => {
                if (event == 'frank-green:gift-card-added-to-cart') {
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                        cartDrawer.classList.add('animate', 'active');
                    }
                }
            });
        });
    });
};
const updateCartCount = () => {
    events.forEach((event) => {
        window.addEventListener(event, () => {
            fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble')
                .then((response) => response.text())
                .then((text) => {
                const innerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector(selectors.shopifySection).innerHTML;
                const cartCount = document.querySelector(selectors.cartIconBubble);
                if (cartCount) {
                    cartCount.innerHTML = innerHTML;
                }
            })
                .then(() => {
                window.dispatchEvent(new CustomEvent('frank-green:cart-reloaded'));
            });
        });
    });
};
const viewCartDataLayer = () => {
    window.addEventListener('frank-green:cart-reloaded', () => {
        const drawerItemsWrapper = document.querySelector('cart-drawer-items');
        const cartCurrency = drawerItemsWrapper?.getAttribute('data-cart-currency') || '';
        const cartValue = drawerItemsWrapper?.getAttribute('data-cart-value') || '';
        const cartDrawerProducts = document.querySelectorAll('cart-drawer-items .cart-item');
        if (cartDrawerProducts) {
            const cartDrawerData = [];
            cartDrawerProducts.forEach((product, index) => {
                const productSKU = product.getAttribute('data-product-variant-sku') || '';
                const productTitle = product.querySelector('.cart-item__name')?.textContent || '';
                const productPrice = product.querySelector('.price')?.innerHTML || '';
                const productQty = product.querySelector('.quantity__input')?.value || '';
                cartDrawerData.push({
                    item_id: productSKU,
                    item_name: productTitle,
                    index: index + 1,
                    price: productPrice,
                    quantity: productQty,
                    item_list_id: 'cart-drawer',
                    item_list_name: 'Cart Drawer',
                });
            });
            window.dataLayer.push({
                event: 'view_cart',
                ecommerce: {
                    currency: cartCurrency,
                    value: cartValue,
                    items: cartDrawerData,
                },
            });
        }
    });
};
const checkoutButton = () => {
    const cartDrawer = document.querySelector(selectors.cartDrawer);
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            const checkoutButton = document.querySelector(selectors.checkoutButton);
            if (checkoutButton) {
                checkoutButton.addEventListener('click', () => {
                    checkoutButton.classList.add('loading-checkout');
                });
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(cartDrawer, config);
};
export { checkoutButton, updateCartDrawerElements, updateCartCount, viewCartDataLayer };
